import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import EmptyState from 'Root/Component/empty-state'

const PlaceholderVideo = () => (
  <EmptyState backgroundColor="linear-gradient(80.03deg, #F76B1C -20.05%, #F9F871 74.81%)">
    <Trans>
      <Title size="2XS">Stiamo facendo della magia...</Title>
      <Paragraph className="text-gray-900">
        il video sarà pronto tra circa
        <span className="font-bold"> 1 minuto</span>.
      </Paragraph>
    </Trans>
  </EmptyState>
)

export default PlaceholderVideo
